import type { CreateOfferCargoFormSchemaType } from "@/pages/admin-cargo-detail/model/validation";
import { fromIso8601Date, toIso8601Date } from "@/shared/lib/datetime";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseDatePicker } from "@/shared/ui/base-date-picker";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { AccordionDetails, Box } from "@mui/material";
import { type Control, Controller } from "react-hook-form";

export const ScheduleForm = ({
  control,
}: { control: Control<CreateOfferCargoFormSchemaType> }) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>配送スケジュール</BaseAccordionSummary>
      <AccordionDetails>
        <Box display="flex" gap={3}>
          <BaseFormLabel label="積日" isRequired>
            <Controller
              name="loadingOn"
              control={control}
              render={({ field, fieldState }) => (
                <BaseDatePicker
                  {...field}
                  value={field.value ? fromIso8601Date(field.value) : undefined}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  onChange={(v) => {
                    field.onChange(v ? toIso8601Date(v) : null);
                  }}
                />
              )}
            />
          </BaseFormLabel>
          <BaseFormLabel label="卸日" isRequired>
            <Controller
              name="unloadingOn"
              control={control}
              render={({ field, fieldState }) => (
                <BaseDatePicker
                  {...field}
                  value={field.value ? fromIso8601Date(field.value) : undefined}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                  onChange={(v) => {
                    field.onChange(v ? toIso8601Date(v) : null);
                  }}
                />
              )}
            />
          </BaseFormLabel>
        </Box>
      </AccordionDetails>
    </BaseAccordion>
  );
};
